<template>
  <div class="resource-map-data-page col-block width-full" :class="{ selectable: selectable }">
    <div class="resource-map-data-main-container row-block flex-start">
      <div class="resource-map-data-avatar-container center-block" @click="e => selectable ? $emit('select', data) : ''">
        <img :src="active ? require('../../assets/images/resource-avatar-active.svg') : require('../../assets/images/resource-avatar.svg')" alt="">
      </div>
      <div class="resource-map-data-info-container col-block width-full" :style="{ flex: 1 }">
        <div class="resource-map-data-info-block row-block flex-start" v-for="(infoOption, ioindex) in infoOptions" :key="ioindex">
          <div class="resource-map-data-info-title">{{ infoOption.title }}</div>
          <div class="resource-map-data-info-content break-line" :style="{ flex: 1 }">{{ infoOption.value(data) || '- -' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: () => false
    },
    selectable: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    // static
    infoOptions () {
      return [
        {
          title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___doctor'),
          value: data => data.name
        },
        {
          title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___address'),
          value: data => [data.country, data.city].filter(x => x).join(' ')
        },
        {
          title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___hospital'),
          value: data => data.hospital
        },
        {
          title: this.$t('COMPONENT.resourceMap.data.infoOption.title.___department'),
          value: data => data.department
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resourceMap/data.vue